import { ComponentsOverrides } from '@mui/material/styles/overrides';
import { Colors } from './colors';

export const InputThemeStyles: {
  styleOverrides: ComponentsOverrides['MuiInput'];
} = {
  styleOverrides: {
    root: {
      height: 45,
      borderRadius: 5,
      fontSize: 16,
      lineHeight: '24px',
      textTransform: 'none',
      padding: 10,
      width: '100%',
      border: `1px solid ${Colors.dark_grey}`,
      '&:before, :after, :hover:not(.Mui-disabled):before': {
        borderBottom: 0,
      },
    },
  },
};
